import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
//import { unescapeIdentifier } from '@angular/compiler';

@Component({
  selector: 'app-manage-groups',
  templateUrl: './manage-groups.component.html'
})
export class ManageGroupsComponent implements OnInit {
  displayedColumns: string[] = ['tagName','actions'];
  dataSource:any = new MatTableDataSource<any>();
  userGroups:any;
  @Input() set userId(value: any) {
    this._userId = value;
    this.getGroups();
  }
  @Input() set userName(value: any) {
    this._userName = value;
    //this.getGroups();
  }
  @Input() set status(value: any) {
    this._status = value;
  }

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  //@ViewChild('Paginator', {static: true}) paginator: MatPaginator;
  private paginator: MatPaginator;
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.paginateOrder();
  }
  
  private _userId: any;
  _status: any;
  _userName: any;
  selectedGroups = [];
  document: File;
  documentPreview: any;
  docs: any;
  documentDate: any;

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    public functionsService:FunctionsService) { 
      this.documentDate = functionsService;
  }

  dropdownList = [];
  selectedItems = [];
  totalLength = 0;
  dropdownSettings = {};
  maxGroups: any;

  ngOnInit() {
    if(localStorage.getItem('language') != null){
      this.functionsService.useLanguageRed(localStorage.getItem('language'));
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'tagId',
      textField: 'tagName',
      selectAllText: this.translate.instant("general.select_all"),
      unSelectAllText: this.translate.instant("general.unselect_all"),
      searchPlaceholderText: this.translate.instant('general.search'),
      noDataAvailablePlaceholderText: this.translate.instant('general.no_data_avail'), 
      itemsShowLimit: 5,
      allowSearchFilter: true
    };
  }

  onItemSelect(item: any) {
    this.selectedItems.push();
    this.userGroupValid();
  }
  onSelectAll(items: any) {
    this.selectedItems = [];
    items.forEach(element => {
      this.selectedItems.push(element);
    });
    this.userGroupValid();
  }
  onItemDeSelect(item: any) {
    const index: number = this.selectedItems.indexOf(item);
    if (index !== -1) {
        this.selectedItems.splice(index, 1);
    }   
    if(this.selectedItems.length == 0){
      this.userGroupErr("required");
    }
  }
  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.userGroupErr("required");
  }

  userGroupValid(){
    let elements = document.getElementsByClassName("dropdown-btn");
    let display = elements.item(0) as HTMLElement;
    display.style.border = "1px solid #adadad";
    document.getElementById("error").innerHTML = "";
  }

  userGroupErr(error){
    let elements = document.getElementsByClassName("dropdown-btn");
    let display = elements.item(0) as HTMLElement;
    display.style.border = "1px solid #dc3545";
    if(error == "maxGroups"){
     document.getElementById("error").innerHTML = this.translate.instant("group.max_groups").replace("##MAX_GROUPS##", this.maxGroups);
    }
    else{
     document.getElementById("error").innerHTML = this.translate.instant("general.required_field");
    }
  }

  paginateOrder(){
    if(this.paginator&&this.sort){
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      //document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
    }
  }

  getGroups() {
    this.dropdownList = [];
    this.spinner.show();
    this.apiService.getUserGroupsCounted(this._userId).subscribe(
      data => {
          this.userGroups = Object.values(data)[0];
          this.maxGroups = Object.keys(data)[0];

          this.dataSource.data = this.userGroups;
          this.paginateOrder();
          this.spinner.hide();
          this.totalLength = this.userGroups? this.userGroups.length:0;

          this.apiService.getGroups().subscribe(
              data => {
                  let jsonString = JSON.stringify(data);
                  let jsonObject = JSON.parse(jsonString);
                  let splitName: any;
                  
                  if (jsonObject != null) {
                    var groupList = [];
                      for (var i = 0; i < jsonObject.length; i++) {
                          var u = ((this.userGroups != null) && !this.userGroups.some(function (group) { return group.tagId === jsonObject[i].id }));
                          if (this.userGroups == null || (u)) {
                              splitName = jsonObject[i].name.split("#");
                              groupList.push({ tagId: jsonObject[i].id, tagName: splitName[0] });
                          }
                      }
                  }
                  this.dropdownList = groupList;
                  this.spinner.hide();
              },
              error => {
                  this.spinner.hide();
                  this.functionsService.errorHandler(error["status"]);
              }
          );
      },
      error => {
          this.spinner.hide();
          this.functionsService.errorHandler(error["status"]);
      });
  }

  saveSelectedGroups(){
    if(this.selectedItems.length == 0){
      this.userGroupErr("required");
      return;
    } 
    if((this.selectedItems.length + this.totalLength) > this.maxGroups){
      this.userGroupErr("maxGroups");
      return;
    }
    this.spinner.show();
    //Concatenate existing user groups with new groups 
    var totalGroups = this.userGroups!=null?this.selectedItems.concat(this.userGroups):this.selectedItems;
    
    this.apiService.saveUserGroups(this._userId,totalGroups)
    .subscribe(resp => {
      if(resp==null){
        this.functionsService.errorHandler(400);
      }
      this.selectedItems = [];
      this.getGroups();
      this.spinner.hide();
    }, error => {
      this.functionsService.errorHandler(error["status"]);
      this.spinner.hide();
    });
  }

  deleteGroup(groupId){
    this.spinner.show();
    this.apiService.deleteUserGroup(this._userId,groupId)
    .subscribe(() => {
      this.spinner.hide();
      this.getGroups();
    }, error => {
      this.spinner.hide();
      this.functionsService.errorHandler(error["status"]);
    });
  }
}
